export default __webpack_public_path__ + "static/media/3-100.0b8c5eb6.jpg";